module.exports = __webpack_public_path__ + "static/media/C1_REFL.898ffa1d.png";